import { Injectable } from '@angular/core';
import { addIcons } from 'ionicons';
import {
  add,
  addOutline,
  airplaneOutline,
  alarm,
  alert,
  alertCircle,
  alertCircleOutline,
  alertCircleSharp,
  archive,
  arrowBackOutline,
  arrowForward,
  arrowForwardOutline,
  arrowUndo,
  attachOutline,
  ban,
  barChart,
  barChartOutline,
  barcode,
  barcodeOutline,
  build,
  buildOutline,
  buildSharp,
  calendarOutline,
  call,
  callOutline,
  camera,
  cameraOutline,
  car,
  caretDownOutline,
  caretUpOutline,
  chatboxEllipses,
  chatbubblesOutline,
  checkbox,
  checkmark,
  checkmarkCircle,
  checkmarkCircleOutline,
  checkmarkOutline,
  chevronBack,
  chevronBackOutline,
  chevronDown,
  chevronDownOutline,
  chevronForward,
  chevronForwardOutline,
  chevronUpOutline,
  close,
  closeCircleOutline,
  closeOutline,
  construct,
  constructOutline,
  copy,
  copyOutline,
  createOutline,
  document,
  documentTextSharp,
  ellipse,
  ellipsisHorizontal,
  ellipsisVertical,
  exitOutline,
  exit,
  extensionPuzzle,
  eye,
  eyeOff,
  eyeOutline,
  filter,
  flag,
  flashlight,
  flashOutline,
  folder,
  folderOpen,
  folderOutline,
  funnel,
  gitMerge,
  gitNetwork,
  hardwareChip,
  hardwareChipOutline,
  helpBuoyOutline,
  helpCircle,
  home,
  homeOutline,
  image,
  infinite,
  informationCircle,
  informationCircleOutline,
  link,
  listOutline,
  locateOutline,
  location,
  locationOutline,
  lockClosed,
  lockClosedOutline,
  mail,
  mailOutline,
  menu,
  navigate,
  newspaperOutline,
  notificationsOutline,
  notificationsOffOutline,
  notifications,
  openOutline,
  pause,
  pencil,
  pencilSharp,
  people,
  person,
  personCircle,
  phonePortraitOutline,
  play,
  qrCode,
  radioButtonOffOutline,
  radioButtonOnOutline,
  reader,
  refresh,
  remove,
  removeCircleOutline,
  repeatOutline,
  scanOutline,
  search,
  searchOutline,
  settingsSharp,
  shapes,
  shareSocial,
  sparklesOutline,
  speedometerOutline,
  square,
  squareOutline,
  star,
  starOutline,
  statsChartOutline,
  stopCircle,
  stopCircleOutline,
  swapHorizontal,
  swapVerticalOutline,
  sync,
  thermometerOutline,
  thumbsDown,
  thumbsUp,
  timeOutline,
  timer,
  timerOutline,
  todayOutline,
  trash,
  trendingDown,
  trendingUp,
  volumeHigh,
  warning,
  warningOutline,
  warningSharp,
  wifiOutline,
  hourglassOutline,
  bulbOutline,
  cash,
} from 'ionicons/icons';

@Injectable({
  providedIn: 'root',
})
export class IconsProvider {
  registerIcons() {
    let icons = {
      'info-circle': 'assets/images/common/info-circle.svg',
      signature: 'assets/images/common/signature.svg',
      pen: 'assets/images/files/pen.svg',
      'closed-folder': 'assets/images/files/closed-folder.svg',
      'open-folder': 'assets/images/files/open-folder.svg',
      'agenda-vue-jour': 'assets/images/agenda/view_day.svg',
      meeting: 'assets/images/agenda/meeting.svg',
      'agenda-vue-equipe': 'assets/images/agenda/equipe.svg',
      'agenda-indisponibilite': 'assets/images/agenda/indisponibilite.svg',
      'agenda-controle-reglementaire': 'assets/images/agenda/controle_reglementaire.svg',
      'agenda-navigation': 'assets/images/agenda/navigation.svg',
      'iot-home': 'assets/images/iot/capteur_home.svg',
      'crt-home': 'assets/images/crt/home.svg',
      'menu-dysfonctionnement': 'assets/images/dysfonctionnement.svg',
      'demande-de-travaux-white': 'assets/icon/demande-de-travaux-white.svg',
      'demande-de-travaux-nofill': 'assets/icon/demande-de-travaux-nofill.svg',
      'demande-de-travaux': 'assets/icon/demande-de-travaux.svg',
      done: 'assets/icon/done.svg',
      task: 'assets/icon/task.svg',
      'list-all': 'assets/icon/list-all.svg',
      'done-all': 'assets/icon/done-all.svg',
      robot: 'assets/icon/robot.svg',
      'agenda-localisation': 'assets/images/agenda/localisation.svg',
      'copy-icon': 'assets/images/common/copy-icon.svg',
      'zoom-minus': 'assets/images/agenda/zoom-minus.svg',
      'zoom-plus': 'assets/images/agenda/zoom-plus.svg',
      'download-fill': 'assets/images/crt/download_fill.svg',
      'location-on': 'assets/images/crt/location_on.svg',
      'iot-chevron-right': 'assets/images/iot/chevron-right.svg',
      'iot-chevron-left': 'assets/images/iot/chevron-gauche.svg',
      'iot-besoin-pose': 'assets/images/iot/besoin-pose.svg',
      'iot-capteur': 'assets/images/iot/capteur.svg',
      'iot-besoin-intervention': 'assets/images/iot/besoin-intervention.svg',
      'iot-signal-capteur-bon': 'assets/images/iot/signal-capteur-bon.svg',
      'iot-signal-capteur-faible': 'assets/images/iot/signal-capteur-faible.svg',
      'iot-signal-capteur-mauvais': 'assets/images/iot/signal-capteur-mauvais.svg',
      'iot-change-voie': 'assets/images/iot/change-voie.svg',
      'iot-comptage': 'assets/images/iot/comptage.svg',
      'iot-temperature': 'assets/images/iot/temperature.svg',
      'iot-temperature-ambiante': 'assets/images/iot/t-ambiante.svg',
      'iot-temperature-exterieur': 'assets/images/iot/t-exterieur.svg',
      'iot-contact-sec': 'assets/images/iot/contact-sec.svg',
      'iot-tor': 'assets/images/iot/tor.svg',
      'iot-pression': 'assets/images/iot/pression.svg',
      'iot-co2': 'assets/images/iot/co2.svg',
      'iot-capteur-4-20-ma': 'assets/images/iot/capteur-4-20-ma.svg',
      'iot-niveau-liquide': 'assets/images/iot/niveau-liquide.svg',
      'iot-no-signal': 'assets/images/iot/no-signal.svg',
      'iot-non-pose': 'assets/images/iot/non-pose.svg',
      'iot-capteur-generique': 'assets/images/iot/capteur-generique.svg',
      'iot-power': 'assets/images/iot/power.svg',
      'iot-fleche-droite': 'assets/images/iot/fleche-droite.svg',
      'iot-poubelle': 'assets/images/iot/poubelle.svg',
      'iot-success': 'assets/images/iot/success.svg',
      'iot-supprime': 'assets/images/iot/supprime.svg',
      'iot-provisionning-success': 'assets/images/iot/provisionning-success.svg',
      'iot-cloud-off': 'assets/images/iot/cloud-off.svg',
      'iot-check': 'assets/images/iot/check.svg',
      'iot-error-input': 'assets/images/iot/error-input.svg',
      'iot-qrcode': 'assets/images/iot/qr_code.svg',
      'iot-chevron-gauche': 'assets/images/iot/chevron-gauche.svg',
      'crt-user': 'assets/images/crt/user.svg',
      'crt-calendar': 'assets/images/crt/calendar.svg',
      shield: 'assets/images/agenda/shield.svg',
      day: 'assets/icon/day.svg',
      week: 'assets/icon/week.svg',
      month: 'assets/icon/month.svg',
      settingsSharp,
      buildOutline,
      buildSharp,
      wifiOutline,
      airplaneOutline,
      'iot-cr-form-plus': 'assets/images/iot/cr-form-plus.svg',
      cameraOutline,
      arrowForwardOutline,
      camera,
      newspaperOutline,
      person,
      close,
      closeOutline,
      addOutline,
      copyOutline,
      alarm,
      shareSocial,
      locateOutline,
      chevronBackOutline,
      chevronBack,
      chevronUpOutline,
      chevronDownOutline,
      chevronForwardOutline,
      chevronDown,
      infinite,
      sync,
      search,
      listOutline,
      people,
      square,
      squareOutline,
      checkbox,
      filter,
      volumeHigh,
      warning,
      warningOutline,
      warningSharp,
      gitNetwork,
      image,
      document,
      build,
      timer,
      copy,
      removeCircleOutline,
      flashlight,
      ban,
      checkmark,
      checkmarkOutline,
      checkmarkCircle,
      stopCircle,
      gitMerge,
      refresh,
      alert,
      helpCircle,
      exitOutline,
      exit,
      informationCircle,
      calendarOutline,
      caretDownOutline,
      caretUpOutline,
      reader,
      funnel,
      qrCode,
      folderOutline,
      ellipsisHorizontal,
      phonePortraitOutline,
      radioButtonOffOutline,
      radioButtonOnOutline,
      'crt-lr-data-histo': 'assets/images/crt/lr-data-histo.svg',
      'crt-blocage-outline': 'assets/images/crt/blocage-outline.svg',
      'crt-blocage-fill': 'assets/images/crt/blocage-fill.svg',
      'crt-favoris-tab': 'assets/images/crt/favoris.svg',
      'crt-organisation': 'assets/images/crt/organisation.svg',
      'crt-recherche': 'assets/images/crt/recherche.svg',
      'crt-multicourbe': 'assets/images/crt/multicourbes.svg',
      'crt-drag-drop': 'assets/images/crt/edition-drag-drop.svg',
      'crt-blocage-site': 'assets/images/crt/blocage-site.svg',
      'crt-blocage-donnee': 'assets/images/crt/blocage-donnee.svg',
      'crt-presence-personnel': 'assets/images/crt/presence-personnel.svg',
      'crt-presence-personnel-part': 'assets/images/crt/presence-personnel-outline.svg',
      'crt-information': 'assets/images/crt/information.svg',
      'crt-multisites': 'assets/images/crt/multisites.svg',
      'crt-envoi-manuel': 'assets/images/crt/envoi-manuel.svg',
      searchOutline,
      'crt-filter-search': 'assets/images/crt/filter-search.svg',
      starOutline,
      star,
      chevronForward,
      'crt-filter': 'assets/images/crt/filter-search.svg',
      alertCircle,
      alertCircleOutline,
      alertCircleSharp,
      informationCircleOutline,
      sparklesOutline,
      closeCircleOutline,
      constructOutline,
      todayOutline,
      timerOutline,
      speedometerOutline,
      location,
      locationOutline,
      folder,
      folderOpen,
      'crt-news': 'assets/images/crt/news.svg',
      'crt-indispo': 'assets/images/crt/indispo.svg',
      menu,
      construct,
      notificationsOutline,
      notificationsOffOutline,
      notifications,
      eye,
      eyeOff,
      eyeOutline,
      car,
      pause,
      play,
      openOutline,
      helpBuoyOutline,
      timeOutline,
      barcodeOutline,
      barcode,
      barChart,
      barChartOutline,
      ellipsisVertical,
      arrowBackOutline,
      arrowForward,
      'crt-edit': 'assets/images/crt/edit.svg',
      'crt-historiques': 'assets/images/crt/historiques.svg',
      'crt-historiques-barre': 'assets/images/crt/historiques-barre.svg',
      'crt-donnees': 'assets/images/crt/donnees.svg',
      'crt-lr-ph': 'assets/images/crt/lr-ph.svg',
      'crt-ic-menu-bottom-details': 'assets/images/crt/ic-menu-bottom-details.svg',
      'crt-events': 'assets/images/crt/events.svg',
      'crt-arret-comm': 'assets/images/crt/arret-comm.svg',
      home,
      homeOutline,
      createOutline,
      mail,
      call,
      pencilSharp,
      'crt-feuille': 'assets/images/crt/feuille.svg',
      'crt-ic-corps-close': 'assets/images/crt/ic-corps-close.svg',
      'iot-commentaire': 'assets/images/iot/commentaire.svg',
      'back-arrow': 'assets/images/back-arrow.svg',
      'iot-triangle-non-pose': 'assets/images/iot/triangle-non-pose.svg',
      'iot-provisionning-echec': 'assets/images/iot/provisionning-echec.svg',
      'iot-reload': 'assets/images/iot/reload.svg',
      'crt-date': 'assets/images/crt/date.svg',
      'crt-vue': 'assets/images/crt/vue.svg',
      'crt-envoi-auto': 'assets/images/crt/envoi-auto.svg',
      'crt-ic-corps-envoi': 'assets/images/crt/ic-corps-envoi.svg',
      'crt-delete': 'assets/images/crt/suppr-poubelle.svg',
      'crt-chevron': 'assets/images/crt/chevron.svg',
      'crt-pen-right': 'assets/images/crt/pen-right.svg',
      'crt-pen-left': 'assets/images/crt/pen-left.svg',
      'crt-menu-copier': 'assets/images/crt/menu-copier.svg',
      'crt-menu-coller': 'assets/images/crt/menu-coller.svg',
      'crt-menu-suppr': 'assets/images/crt/menu-suppr.svg',
      repeatOutline,
      mailOutline,
      personCircle,
      chatboxEllipses,
      chatbubblesOutline,
      trash,
      link,
      thermometerOutline,
      add,
      remove,
      pencil,
      stopCircleOutline,
      ellipse,
      thumbsDown,
      thumbsUp,
      'crt-ic-head-telephonie': 'assets/images/crt/ic-head-telephonie.svg',
      'crt-details': 'assets/images/crt/details.svg',
      trendingDown,
      trendingUp,
      'md-close': 'assets/images/iot/close.svg',
      lockClosedOutline,
      archive,
      flag,
      'crt-mesure': '/assets/images/crt/mesure.svg',
      'crt-historique-mini': '/assets/images/crt/historique-mini.svg',
      'crt-house': '/assets/images/crt/house.svg',
      'crt-ph-zones': 'assets/images/crt/ph-zones.svg',
      'crt-ph-calques': 'assets/images/crt/ph-calques.svg',
      swapHorizontal,
      hardwareChip,
      checkmarkCircleOutline,
      'crt-ic-photo': 'assets/images/crt/ic-photo.svg',
      'crt-ic-photo-lightning': 'assets/images/crt/ic-photo-lightning.svg',
      histo: 'assets/images/histo.svg',
      echapetbelle: 'assets/icon/echap-belle.svg',
      cloud: 'assets/icon/weather/cloud.svg',
      'sun-shy': 'assets/icon/weather/sun-shy.svg',
      'heavy-sun': 'assets/icon/weather/heavy-sun.svg',
      'little-rain': 'assets/icon/weather/little-rain.svg',
      'heavy-rain': 'assets/icon/weather/heavy-rain.svg',
      'some-wind': 'assets/icon/weather/some-wind.svg',
      'big-wind': 'assets/icon/weather/big-wind.svg',
      'gravite-alerte': 'assets/icon/gravite_alerte.svg',
      'gravite-warning': 'assets/icon/gravite_warning.svg',
      scanOutline,
      hardwareChipOutline,
      zone: 'assets/icon/localisation/zone.svg',
      batiment: 'assets/icon/localisation/batiment.svg',
      niveau: 'assets/icon/localisation/niveau.svg',
      aire: 'assets/icon/localisation/aire.svg',
      local: 'assets/icon/localisation/local.svg',
      navigate,
      lockClosed,
      documentTextSharp,
      flashOutline,
      statsChartOutline,
      extensionPuzzle,
      shapes,
      attachOutline,
      'ia-assistant': 'assets/icon/ia-assistant.svg',
      swapVerticalOutline,
      'navigate-circle': 'assets/icon/navigate_circle.svg',
      arrowUndo,
      callOutline,
      hourglassOutline,
      bulbOutline,
      'person-digging': 'assets/icon/person-digging.svg',
      cash,
      'wrench-small': 'assets/icon/wrench-small.svg',
      'notification-cr': 'assets/icon/notifications/notification-cr.svg',
      'top-securite': 'assets/icon/top-securite.svg',
      'cube-outline': 'assets/icon/cube-outline.svg',
      'hard-hat': 'assets/icon/hard-hat.svg',
      'home-work': 'assets/icon/home-work.svg',
    };
    this.registerIconesPortailSecurite(icons);
    addIcons(icons);
  }

  registerIconesPortailSecurite(icons: { [name: string]: string }) {
    for (let i = 1; i < 102; i++) {
      let key = 'eb-' + i;
      icons[key] = 'assets/icon/eb/' + i + '.svg';
    }
    icons['eb-900'] = 'assets/icon/eb/900.svg';
    icons['eb-901'] = 'assets/icon/eb/901.svg';
  }
}
